import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ThemePropertyEntity } from './theme-property.entity';

@Index('_name', ['name'], { unique: true })
@Entity('_theme')
export class ThemeEntity extends BaseEntity {
	@Column('varchar', { name: '_name', unique: true, length: 64 })
	public name!: string;

	@Column('int', { name: '_extends', nullable: true, unsigned: true })
	public extends!: number | null;

	@OneToMany(
		() => ThemePropertyEntity,
		(themeProperty) => themeProperty.fkTheme,
		{},
	)
	public themeProperties!: Array<ThemePropertyEntity>;
}
